var Backbone = require('backbone')
var _ = require('lodash')

var PageableCollection = require('backbone.paginator')
// adjusted pageable collection to support the "skip" way of Feathersj
var Collection = PageableCollection.extend({
  state: {
    firstPage: 0,
    pageSize: 15
  },
  fetching: false,
  queryParams: {
    currentPage: '$page',
    pageSize: '$limit',
    totalRecords: null,
    totalPages: null
  },
  initialize: function (models, options) {
    // simple system which keeps track if the collection is fetching or not
    // the this.fetching parameter is set to true once the system started fetching and set to false when done
    this.listenTo(this, 'request loading', function () {
      this.fetching = true
    })
    this.listenTo(this, 'sync loaded error reset destroy', function () {
      this.fetching = false
    })

    // when the pagination is set to false, disable the pagination of the collection
    if (_.has(options, 'pagination')) {
      //   console.log('has pagination property set')
      if (!options.pagination) {
        _.set(options, 'state.firstPage', null)
        _.set(options, 'state.pageSize', null)
      }
    }

//    var self = this
    // setTimeout(function () {
    //   console.log(self)
    //   console.log(self.hasNextPage())
    //   self.setPageSize()
    // }, 3000)
  },
  fetch: function (options) {
    // when data is given to be sent as query parameters
    // keep track of them, to correctly send them everytime a new request is fired
    // through the paginator. The paginator use the queryParams property but this isn't cleaned
    // after the call and we dont want to clogg up this property with a lot of values.
    if (options) {
      if (this.queryParams && options.hasOwnProperty('data')) {
        // if there is previous data, clean up the queryParams property
        if (this.prevDataKeys) {
          for (var i = 0; i < this.prevDataKeys.length; i++) {
            var key = this.prevDataKeys[i]
            delete this.queryParams[key]
          }
        }

        _.extend(this.queryParams, options.data)

        if (options.data) {
          if (Object.keys(options.data).length > 0) {
            this.prevDataKeys = Object.keys(options.data)
          }
        }
      }
    }

    PageableCollection.prototype.fetch.apply(this, arguments)
  },
  parseState: function (resp, queryParams, state, options) {
    // when the skip value equals the total nr of records, we don't have a result
    // this happes for example when you change the filter after paginating and thus receiving
    // a lower amount of pages that the current page
    if (resp.skip >= resp.total && resp.skip > 0) {
      return this.getFirstPage()
    }

    let responseTotal = resp.total

    // somehow when set to infinite mode the totalRecords are calculated differently.
    // this fixes this by removing the pagesize from the returned total
    if (this.mode === 'infinite') responseTotal -= state.pageSize

    // return to total recors for usage with feathersjs api
    return {
      totalRecords: responseTotal
    }
  },
  parseRecords: function (resp, options) {
    if (!resp.data) return resp
    return resp.data
  },
  sortByField: function (field) {
    if (_.has(this, 'sortParams.field')) {
      if (this.sortParams.direction === 1) {
        this.sortParams.direction = -1
      } else {
        this.sortParams.direction = 1
      }
    }
    if (!_.has(this, 'sortParams') || this.sortParams.field !== field) this['sortParams'] = {'field': field, 'direction': -1}

    //
    var sortField = this.sortParams.field
    if (this.sortParams.direction === -1) sortField = '-' + sortField

    this.queryParams['$sort'] = sortField
    this.fetch()
  },
  getBulkCount: function () {
    let bulkIds = this.getBulkIds()
    return bulkIds.length
  },
  getBulkIds: function () {
    var bulkModels = this.where({'_bulk': true})
    if (bulkModels.length <= 0) return false
    let bulkIds = bulkModels.map(function (model) {
      return model.get('_id')
    })
    return bulkIds
  },
  bulkPatch: function (data, options) {
    var self = this

    var defaultOptions = {
      updateCollection: true
    }
    var options = _.extend(defaultOptions, options)

    // get a list of model id's to address in the bulk save
    var bulkIds = self.getBulkIds()

    // console.log(data)
    Backbone.ajax({
      method: 'PATCH',
      url: self.url + '/?_id=' + bulkIds.join(','),
      data: JSON.stringify(data),
      success: function (val) {
        if (options.updateCollection) self.add(val, {merge: true})
        if (options.callback) options.callback(null, val)
      },
      error: function (err) {
        if (options.callback) options.callback(err)
      }
    })
  },
  bulkPost: function (data, options) {
    var self = this

    var defaultOptions = {
      updateCollection: true
    }
    var options = _.extend(defaultOptions, options)

    // get a list of model id's to address in the bulk save
    var bulkIds = self.getBulkIds()

    // console.log(data)
    Backbone.ajax({
      method: 'POST',
      url: self.url + '/?_id=' + bulkIds.join(','),
      data: JSON.stringify(data),
      success: function (val) {
        if (options.updateCollection) self.add(val, {merge: true})
        if (options.callback) options.callback(null, val)
      },
      error: function (err) {
        if (options.callback) options.callback(err)
      }
    })
  },
  bulkDelete: function (options) {
    var self = this

    var defaultOptions = {
      updateCollection: true
    }
    var options = _.extend(defaultOptions, options)

    // get a list of model id's to address in the bulk save
    var bulkIds = self.getBulkIds()

    Backbone.ajax({
      method: 'DELETE',
      url: self.url + '/?_id=' + bulkIds.join(','),
      success: function (val) {
        if (options.updateCollection) self.remove(val, {merge: true})
        if (options.callback) options.callback(null, val)

        // quick fix to deal with pagination showing empty pages after deleting record
        // if this is a pagination collection refetch the current page to fix
        // any pagination incosistencies due to deleting items from the page
        if (self.state) self.getPage(self.state.currentPage)
      },
      error: function (err) {
        if (options.callback) options.callback(err)
      }
    })
  }

})

var FilterableCollection = Collection.extend({
  initialize: function (models) {
    this.filtered = new Backbone.Collection(models)
    this.debouncedFilter = _.debounce(this.refilter, 100, {trailing: true})
    this.listenTo(this, 'add remove sync', this.debouncedFilter)

    Collection.prototype.initialize.apply(this, arguments)
  },

  filterBy: function (params) {
    var filteredColl = this.filter(function (item) {
      if (!params) return true

      return ~item.get('name').indexOf(params.name)
    })

    this.filtered.params = params
    this.filtered.reset(filteredColl)
  },

  refilter: function () {
    this.filterBy(this.filtered.params)
  }
})

module.exports = FilterableCollection



// WEBPACK FOOTER //
// ./js/common/base-collection.js